import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { AuthCallbackPage } from '@/features/auth/AuthCallbackPage';
import { LoginPage } from '@/features/auth/LoginPage';
import { RequireAuth } from '@/features/auth/RequireAuth';
import { ChatPage } from '@/features/chat/ChatPage';
import { ProjectsPage } from '@/features/projects/ProjectsPage';

/**
 * Three screens: sign in, pick a product, work on it.
 *
 * There is no conversation list and no chat id in any URL - one chat per
 * project means the project is the address.
 */
export function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <AppShell>
                <ProjectsPage />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route
          path="/projects/:projectId"
          element={
            <RequireAuth>
              <AppShell>
                <ChatPage />
              </AppShell>
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
